import 'firebase/messaging';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PushNotificationToken } from '../../types/push-notification-token';
import { environment } from 'src/environments/environment';
import { NativePushNotificationService } from './native-push-notification.service';
import { WebPushNotificationService } from './web-push-notification.service';
import { Capacitor } from '@capacitor/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  private _host = environment.apiUrl;

  constructor(
    private _http: HttpClient,
    private _webPushService: WebPushNotificationService,
    private _nativePushService: NativePushNotificationService,
  ) {
    _webPushService.tokenReceived.subscribe((token) =>
      this.registerToken({
        token,
        platform: 'web',
        domain: location.origin,
      }),
    );
    _nativePushService.tokenReceived.subscribe((token) =>
      this.registerToken({ token, platform: 'android' }),
    );
  }

  public requestPermission() {
    if (Capacitor.getPlatform() === 'web') {
      return this._webPushService.requestPermission();
    } else {
      return this._nativePushService.requestPermission();
    }
  }

  public canRequestPermission(): Observable<boolean> {
    if (Capacitor.getPlatform() === 'web') {
      return of(this._webPushService.canRequestPermission());
    } else {
      return this._nativePushService.canRequestPermission();
    }
  }

  private registerToken(tokenData: PushNotificationToken) {
    const requestUrl = `${this._host}/api/User/push-quest-complete`;
    this._http.put<any>(requestUrl, tokenData).subscribe();
  }
}
